<template>
  <el-dialog title="补全个人信息" :visible.sync="dialogVisible" width="960px" :close-on-click-modal="false">
    <el-form :rules="formInfoRules" ref="formInfo" :model="formInfo" label-width="100px">
      <el-form-item label="姓名" prop="nickName">
        <el-input v-model="formInfo.nickName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="工号" prop="userName">
        <el-input v-model="formInfo.userName" placeholder="请输入" clearable disabled></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="phonenumber">
        <el-input type="number" v-model="formInfo.phonenumber" placeholder="请输入" disabled clearable></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="password">
        <el-input v-model="formInfo.password" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="年龄" prop="age">
        <el-input type="number" v-model="formInfo.age" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="性别" prop="sex">
        <el-select class="m-input" v-model="formInfo.sex" placeholder="请选择" clearable>
          <el-option label="男" value="1"></el-option>
          <el-option label="女" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="身份证" prop="idNumber">
        <el-input v-model="formInfo.idNumber" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="学历" prop="qualifications">
        <el-input v-model="formInfo.qualifications" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="公司" prop="company">
        <el-input v-model="formInfo.company" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="formInfo.email" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="民族" prop="nation">
        <el-input v-model="formInfo.nation" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="政治面貌" prop="politicalOutlook">
        <el-input v-model="formInfo.politicalOutlook" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="职务工种" prop="workType">
        <el-input v-model="formInfo.workType" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="所属铁路局" prop="railway">
        <el-input v-model="formInfo.railway" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="期别" prop="period">
        <el-input v-model="formInfo.period" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="memo">
        <el-input type="textarea" v-model="formInfo.memo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="头像">
        <el-upload class="avatar-uploader" :action="upAction" name="file" :headers="uploadHeader"
          :show-file-list="false" :on-success="uploadSuccess">
          <img class="avatar" v-if="formInfo.avatar" :src="formInfo.avatar | fileFilter">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="resetForm('formInfo')">取 消</el-button>
      <el-button type="primary" @click="submitForm('formInfo')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import Auth from "@/utils/Auth";
  import CommonFilters from "@/mixins/CommonFilters";
  import WebSocketUtil from "@/utils/WebSocketUtil";
  export default {
    name: "StudentInfo",
    mixins: [CommonFilters],
    data () {
      return {
        upAction: "",
        uploadHeader: {
          Authorization: ""
        },
        formInfo: {},
        formInfoRules: {
          nickName: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          password: [
            { required: true, message: "密码不能为空,必须有大小写字母，最少6个字符，最多18位", pattern: /^(?=.*[A-Z])+(?=.*[a-z])[^]{6,18}$/, trigger: "change" }
          ],
          sex: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          idNumber: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          qualifications: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          company: [
            { required: true, message: "请输入", trigger: "change" }
          ],
          age: [
            { required: true, message: "请输入", trigger: "change" }
          ],
        },
        dialogVisible: false,
      };
    },
    computed: {
      getUserinfo () {
        return this.$store.state.user.userInfo;
      },
    },
    watch: {
      getUserinfo (newVal, oldVal) {
        let _userInfo = newVal;
        if (_userInfo.supplementFlag && _userInfo.roleId == 101) {
          this.dialogVisible = true;
          this.upAction = process.env.VUE_APP_PREFIX + "/fastdfs/upload/image/sample";
          this.uploadHeader.Authorization = Auth.getToken();
          this.formInfo = {
            "userId": _userInfo.userId,
            "nickName": _userInfo.nickName,
            "userName": _userInfo.userName,
            "phonenumber": _userInfo.phonenumber,
            "email": _userInfo.email,
            "avatar": _userInfo.avatar,
            "password": "",
            "sex": _userInfo.sex,
            "age": _userInfo.age,
            "idNumber": "",
            "nation": "",
            "politicalOutlook": "",
            "qualifications": "",
            "studentFlag": "",
            "workType": _userInfo.workType,
            "railway": "",
            "company": "",
            "period": "",
            "soldierFlag": "",
            "memo": ""
          }
        }
      }
    },
    mounted () {

    },
    methods: {
      submitForm (formInfo) {
        let that = this;
        this.$refs[formInfo].validate((valid) => {
          if (valid) {
            that.HttpConnection.post("/system-user/supplement", that.formInfo).then(function (response) {
              that.$message({
                type: "success",
                message: "操作成功, 请重新登录"
              });
              that.HttpConnection.post("logout").then(function (res) {
                WebSocketUtil.closeWebSocket(true);
                Auth.removeToken();
                localStorage.clear();
                location.reload();
              });
            });
          } else {
            return false;
          }
        });
      },
      resetForm (formInfo) { // 新增 编辑 取消
        this.dialogVisible = false;
      },
      uploadSuccess (res, file) {
        this.formInfo.avatar = res.filePath;
      }
    }
  };
</script>

<style scoped lang="scss">
</style>